import React, { useState } from 'react'
import './CardTable.scss'
import { Button } from 'rsuite'
import { MdDelete as TrashIcon } from 'react-icons/md'
import ConfirmModal from '../modal/ConfirmModal'

interface WhatsAppInfoCardProps {
  data?: {
    id?: string,
    status?: string,
    appName?: string,
    subsId?: number,
    senderId?: string,
    channel?: string,
    channelId?: string,
    phone_id?: string,
    businessInfo?: string,
    dltTemplateId?: string
  };
  confirmDelete?: (rowData: any) => void;
}

const WhatsAppInfoCard: React.FC<WhatsAppInfoCardProps> = ({
  data,
  confirmDelete
}) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  interface BusinessInfo {
    name?: string;
    id?: string;
    owner_business_info?: {
      name?: string
    };
  }

  let businessInfo: BusinessInfo | string = data?.businessInfo ?? '-'

  if (data?.channel === 'INAPP') {
    businessInfo = data.businessInfo ?? '-'
  } else if (data?.businessInfo) {
    try {
      businessInfo = JSON.parse(data.businessInfo)
    } catch (e) {
      businessInfo = data.businessInfo
    }
  }

  return (
    <div className="whatapp-info-card">
      <div className="inner-div">
        <div className="button">
          <Button
            size="xs"
            appearance="default"
            onClick={() => setOpenDeleteModal(true)}
          >
            <TrashIcon size={25} className="delete-button" />
          </Button>
        </div>

        <div className="card-header">
          {(data?.channel === 'WHATSAPP' || data?.channel === 'INAPP') && (
            <h3>
              {typeof businessInfo === 'string'
                ? businessInfo
                : (businessInfo?.name ?? '-')}
            </h3>
          )}
        </div>

        <div className="card-body">
          {data?.channel === 'WHATSAPP' && (
            <>
              <div className="business-card__item">
                <b>WhatsApp Business ID: </b>
                <p>{data?.channelId ?? '-'}</p>
              </div>
              <div className="business-card__item">
                <b>Business Name: </b>
                <p>{data?.businessInfo ?? '-'}</p>
              </div>
            </>
          )}
          {data?.channel === 'INAPP' && (
            <div className="business-card__item">
              <b>App Name: </b>
              <p>{data?.appName ?? '-'}</p>
            </div>
          )}

          {data?.channel === 'SMS' && (
            <>
              <div className="business-card__item">
                <b>SMS Sender ID: </b>
                <p>{data?.senderId ?? '-'}</p>
                <b>SMS DLTTemplate ID: </b>
                <p>{data?.dltTemplateId ?? '-'}</p>
              </div>
              <div className="business-card__item">
                <b>Business Name: </b>
                <p>{data?.businessInfo ?? '-'}</p>
              </div>
            </>
          )}
        </div>
        <ConfirmModal
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          title="Confirm Delete"
          message="Are you sure you want to delete Channel?"
          confirmText={
            <>
              <TrashIcon size={16} /> &nbsp; Yes
            </>
          }
          onConfirm={() => {
            confirmDelete?.(data)
            setOpenDeleteModal(false)
          }}
        />
      </div>
    </div>
  )
}
export default WhatsAppInfoCard
